// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnerTires(_, data) {
            const response = await axios.get(`${MAIN_API}/api/tire-partner`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async getPartnerTireCatalog(_, data) {
            const response = await axios.get(`${MAIN_API}/api/tire/v2/all`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async createTire(_, formData) {
            const response = await axios.post(`${MAIN_API}/api/tire/v2/create`, formData)
            return response.data
        },
        async addPartnerTire(_, data) {
            const response = await axios.post(`${MAIN_API}/api/tire-partner/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getTireBrands() {
            const response = await axios.get(`${MAIN_API}/api/tire-brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getCarBrands() {
            const response = await axios.get(`${MAIN_API}/api/car-brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getCarModels(_, id) {
            const response = await axios.get(`${MAIN_API}/api/car-model/brand/` + id, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getCarDirectory(_, data) {
            const response = await axios.get(`${MAIN_API}/api/car/model/directory/all`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    carBrand: data.brandId,
                    carModel: data.modelId,
                    year: data.year,
                }
            })
            return response.data
        },
        async getCarSpec(_, id) {
            const response = await axios.get(`${MAIN_API}/api/tire/spec/` + id, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
